export default __webpack_public_path__ + "static/media/pcard7.0463db11.png";